import type { UnicastFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/UnicastFormValues';
import type { FormikErrors } from 'formik';
import type { AppTranslations } from 'translations/translations';
import type { MulticastFormValues } from './MulticastFormValues';
import {
  FRAGMENT_OFFSET_MAX,
  FRAGMENT_OFFSET_MIN,
  TTL_MAX,
  TTL_MIN,
  validatePorts,
} from './PathLookupAdvancedOptions';

export const validateAdvancedOptions = (
  msg: AppTranslations,
  values: UnicastFormValues | MulticastFormValues,
): FormikErrors<UnicastFormValues | MulticastFormValues> => {
  const errors: FormikErrors<UnicastFormValues> = {};

  if (
    values.protocol !== 'icmp' &&
    (!values.srcPorts || !validatePorts(values.srcPorts))
  ) {
    errors.srcPorts =
      msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidPorts;
  }

  if (
    values.protocol !== 'icmp' &&
    (!values.dstPorts || !validatePorts(values.dstPorts))
  ) {
    errors.dstPorts =
      msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidPorts;
  }

  if (!values.ttl || values.ttl < TTL_MIN || values.ttl > TTL_MAX) {
    errors.ttl =
      msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidValue;
  }

  if (
    typeof values.fragmentOffset !== 'number' ||
    values.fragmentOffset < FRAGMENT_OFFSET_MIN ||
    values.fragmentOffset > FRAGMENT_OFFSET_MAX
  ) {
    errors.fragmentOffset =
      msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidValue;
  }

  return errors;
};
